import { BeneficiaryInfo } from "./beneficiaryInfo";

export class BeneficiaryInformation {
  constructor(

    public Beneficiary: BeneficiaryInfo[],
    public Contingent: BeneficiaryInfo[],

  ) {}
}
